module.exports = __webpack_public_path__ + "static/BMW1-b12e9047460ca1c46fc843161cb2b3ce.jpg";